<script setup lang="ts">
import './assets/style.scss'
import { computed, type PropType } from 'vue'
import type { InventoryMapTypesDict } from '@/widgets'
import { VIcons } from '@/shared/ui'
import { useHelpers } from '@/shared/lib'

const props = defineProps({
  countsByType: {
    type: Object as PropType<Record<string, number>>,
    required: true,
  },
  types: {
    type: Object as PropType<InventoryMapTypesDict>,
    required: true,
  },
  colocated: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const { getColorForBackground } = useHelpers()
const emits = defineEmits(['selected'])

/** Бейджи по типам кластера — счётчики уже посчитаны сервером (`counts_by_type`). */
const badges = computed(() =>
  Object.entries(props.countsByType).map(([typeId, count]) => {
    const type = props.types[typeId]
    const bgColor = (type?.styles.fill ?? '#999999').slice(0, 7)

    return {
      typeId,
      icon: type?.icon ?? 'category',
      bgColor,
      color: getColorForBackground(bgColor),
      count,
    }
  }),
)

/**
 * Клик по любому бейджу раскрывает весь кластер — сервер не отдаёт id по каждому
 * типу отдельно, только `object_ids` кластера целиком (см. ai/plan_cluster_back.md).
 */
const clickHandler = () => {
  emits('selected')
}
</script>

<template>
  <div
    class="v-map-invent-cluster"
    :class="{
      'v-map-invent-info-marker_disable': disabled,
      'v-map-invent-cluster_stack': colocated,
    }"
    @click.stop="clickHandler"
  >
    <span
      v-for="badge in badges"
      :key="badge.typeId"
      :style="{ backgroundColor: badge.bgColor, color: badge.color }"
    >
      <VIcons :type="badge.icon" />
      {{ badge.count }}
    </span>
  </div>
</template>
